import { render, staticRenderFns } from "./create-testPaperUs.vue?vue&type=template&id=d7180310&scoped=true&"
import script from "./create-testPaperUs.vue?vue&type=script&lang=ts&"
export * from "./create-testPaperUs.vue?vue&type=script&lang=ts&"
import style0 from "./create-testPaperUs.vue?vue&type=style&index=0&id=d7180310&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d7180310",
  null
  
)

export default component.exports